import {useMutation} from '@tanstack/vue-query';
import { getApi } from '../api';

export default () => useMutation({
    mutationFn: ({ dialogId, messageId, rate, comment } : { dialogId: number, messageId: string, rate: number, comment?: string }) => {
        const { api, baseURL } = getApi();
        
        const payload: { dialog_id: number; message_id: string; rate: number; comment?: string } = { 
            dialog_id: dialogId, 
            message_id: messageId, 
            rate 
        };
        if (comment) {
            payload.comment = comment;
        }
        return api.post(`/api/v2/dialogs/${dialogId}/messages/${messageId}/feedback`, payload, { baseURL, useOriginalToken: true }).then(res => res.data.data)
    },
}) 